'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index$1 = require('../../../../../node_modules/classnames/index.js');

var index = require('../../../../../node_modules/prop-types/index.js');

require('../../../../../primitives/Button/Button.js');

require('../../../../../primitives/Hero/Hero.js');

var Icon = require('../../../../../primitives/Icon/Icon.js');

require('../../../../../primitives/Link/Link.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var NavDropdownSidebar = function NavDropdownSidebar(_ref) {
  var activeMenuGroup = _ref.activeMenuGroup,
      activeGroup = _ref.activeGroup,
      className = _ref.className,
      setActiveGroup = _ref.setActiveGroup;
  var navDropdownSidebarClasses = index$1['default'](className, 'lanl-nav-dropdown-sidebar');
  var name = activeMenuGroup.name,
      link = activeMenuGroup.link,
      lc_page_groups = activeMenuGroup.lc_page_groups;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: navDropdownSidebarClasses,
    "data-testid": "lanl-nav-dropdown-sidebar"
  }, /*#__PURE__*/React__default['default'].createElement("ul", {
    className: "sidebar-list"
  }, /*#__PURE__*/React__default['default'].createElement("li", {
    className: "sidebar-item"
  }, name), /*#__PURE__*/React__default['default'].createElement("li", {
    className: "sidebar-item"
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    href: link
  }, "View ", name.toLowerCase())), lc_page_groups.map(function (_ref2) {
    var name = _ref2.name,
        link = _ref2.link,
        lc_pages = _ref2.lc_pages;
    var isActive = activeGroup === name && 'sidebar-item--active';

    if (lc_pages.length > 0) {
      return /*#__PURE__*/React__default['default'].createElement("li", {
        className: "sidebar-item ".concat(isActive),
        key: "sidebar-item-".concat(name),
        onClick: function onClick() {
          setActiveGroup(name);
        }
      }, name, /*#__PURE__*/React__default['default'].createElement(Icon.Icon, {
        icon: "chevron-right",
        size: "sm"
      }));
    } else {
      return /*#__PURE__*/React__default['default'].createElement("li", {
        className: "sidebar-item ".concat(isActive),
        key: "sidebar-item-".concat(name)
      }, /*#__PURE__*/React__default['default'].createElement("a", {
        href: link
      }, name));
    }
  })));
};

NavDropdownSidebar.defaultProps = {};
NavDropdownSidebar.propTypes = {
  activeGroup: index['default'].string,
  activeMenuGroup: index['default'].shape({
    lc_page_groups: index['default'].array,
    link: index['default'].string,
    name: index['default'].string
  }),
  className: index['default'].string,
  setActiveGroup: index['default'].func
};
exports.NavDropdownSidebar = NavDropdownSidebar;
exports['default'] = NavDropdownSidebar;